<template>
    <q-page padding>
        <q-scroll-area class="q-pt-md" style="height: 100%; ">
            <!-- Knobs iterados -->
            <q-list class="rounded-borders">
                <q-expansion-item header-class="bg-white text-primary" default-opened popup icon="mdi-chart-bar"
                    label="Grafica por Región">
                    <q-separator />
                    <q-card class="q-pa-md   text-center">
                        <h5>Gráfica por Región</h5>
                        <canvas height="100px" ref="chartUnidad"></canvas>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item header-class="bg-white text-primary" popup icon="mdi-chart-arc"
                    label="Grafica Global">
                    <q-separator />
                    <q-card class="q-pa-md text-center">
                        <h5>Gráfica Global</h5>
                        <canvas height="50px" ref="chartGlobal"></canvas>
                        <q-separator class="q-my-md" />

                        <q-card borderd class="row justify-around q-col-gutter-mdq-mt-md" v-if="totalesglobales">
                            <div class="col-auto" v-for="(item, i) in indicadores" :key="i">
                                <q-card class="q-pa-sm no-shadow	">
                                    <q-card-section class="text-center">
                                        <div class="text-h6">{{ item.titulo }}</div>
                                        <div class="text-h6 text-primary">{{ item.total }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly v-model="item.progress" show-value size="90px"
                                            :thickness="0.22" :color="item.color" track-color="green-1"
                                            class="text-green">
                                            <template v-if="item.titulo == 'Nuevos'">
                                                + {{ item.progress }}%
                                            </template>
                                            <template v-else>
                                                {{ item.progress }}%
                                            </template>
                                        </q-knob>
                                    </q-card-section>
                                </q-card>
                            </div>
                        </q-card>

                        <!-- <div class="row q-col-gutter-md q-mt-md" v-if="totalesglobales">
                            <div class="col-md-2 col-6">
                                <q-card class="q-pa-sm shadow-0" bordered>
                                    <q-card-section class="text-center">
                                        <div class="text-h6">Localizados</div>
                                        <div class="text-h6 text-primary"> {{ totalesglobales.localizados }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly
                                            :value="progressLabel(totalesglobales.total, totalesglobales.localizados)"
                                            show-value size="90px" :thickness="0.22" color="green" track-color="green-1"
                                            class="text-green" />
                                    </q-card-section>
                                </q-card>
                            </div>

                            <div class="col-md-2 col-6">
                                <q-card class="q-pa-sm shadow-0" bordered>
                                    <q-card-section class="text-center">
                                        <div class="text-h6">Conciliados </div>
                                        <div class="text-h6 text-primary"> {{ totalesglobales.conciliados }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly
                                            :value="progressLabel(totalesglobales.total, totalesglobales.conciliados)"
                                            show-value size="90px" :thickness="0.22" color="green" track-color="green-2"
                                            class="text-green" />
                                    </q-card-section>
                                </q-card>
                            </div>
                            <div class="col-md-2 col-6">
                                <q-card class="q-pa-sm shadow-0" bordered>
                                    <q-card-section class="text-center">
                                        <div class="text-h6">Etiquetados </div>
                                        <div class="text-h6 text-primary"> {{ totalesglobales.etiquetados }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly
                                            :value="progressLabel(totalesglobales.total, totalesglobales.etiquetados)"
                                            show-value size="90px" :thickness="0.22" color="green" track-color="green-3"
                                            class="text-green" />
                                    </q-card-section>
                                </q-card>
                            </div>
                            <div class="col-md-2 col-6">
                                <q-card class="q-pa-sm shadow-0" bordered>
                                    <q-card-section class="text-center">
                                        <div class="text-h6">No Identificados </div>
                                        <div class="text-h6 text-primary"> {{ totalesglobales.noIdentificados
                                            }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly
                                            :value="progressLabel(totalesglobales.total, totalesglobales.noIdentificados)"
                                            show-value size="90px" :thickness="0.22" color="green" track-color="green-4"
                                            class="text-green" />
                                    </q-card-section>
                                </q-card>
                            </div>
                            <div class="col-md-2 col-6">
                                <q-card class="q-pa-sm shadow-0" bordered>
                                    <q-card-section class="text-center">
                                        <div class="text-h6">Total </div>
                                        <div class="text-h6 text-primary"> {{ totalesglobales.total }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly
                                            :value="progressLabel(totalesglobales.total, totalesglobales.total)"
                                            show-value size="90px" :thickness="0.22" color="green" track-color="green-5"
                                            class="text-green" />
                                    </q-card-section>
                                </q-card>
                            </div>
                            <div class="col-md-2 col-6">
                                <q-card class="q-pa-sm shadow-0" bordered>
                                    <q-card-section class="text-center">
                                        <div class="text-h6">Nuevos </div>
                                        <div class="text-h6 text-primary"> {{ totalesglobales.nuevos }}</div>
                                    </q-card-section>
                                    <q-separator />
                                    <q-card-section class="flex flex-center">
                                        <q-knob readonly
                                            :value="progressLabel(totalesglobales.nuevos, totalesglobales.nuevos)"
                                            show-value size="90px" :thickness="0.22" color="green" track-color="green-6"
                                            class="text-green" />
                                    </q-card-section>
                                </q-card>
                            </div>
                        </div> -->
                    </q-card>
                </q-expansion-item>

                <q-expansion-item header-class="bg-white text-primary" popup icon="mdi-chart-bar" label="Personal">
                    <q-separator />
                    <q-card class="q-pa-md">
                        <div class="row q-col-gutter-md">
                            <div class="col-12 col-md-6 text-h6">
                                Rendimiento del Personal
                            </div>
                            <div class="col-12 col-md-3">
                                <q-input outlined dense v-model="fechaI" type="date" label="Fecha Inicial" />
                            </div>
                            <div class="col-12 col-md-3">
                                <q-input outlined dense v-model="fechaF" type="date" label="Fecha Final">
                                    <template v-slot:after>
                                        <q-btn round dense flat icon="mdi-magnify" color="primary"
                                            @click="GetTotalBienesPersonal()" />
                                    </template>
                                </q-input>
                            </div>
                        </div>
                        <canvas height="50px" ref="bienesChart"></canvas>
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="datos && datos.u9" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región U9">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row  justify-around q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u9.total, datos.u9.localizados)" show-value
                                                size="90px" :thickness="0.22" color="green" track-color="green-1"
                                                class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u9.total, datos.u9.localizados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u9.total, datos.u9.conciliados)" show-value
                                                size="90px" :thickness="0.22" color="green" track-color="green-2"
                                                class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u9.total, datos.u9.conciliados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u9.total, datos.u9.etiquetados)" show-value
                                                size="90px" :thickness="0.22" color="green" track-color="green-3"
                                                class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u9.total, datos.u9.etiquetados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u9.total, datos.u9.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u9.total, datos.u9.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u9.total, datos.u9.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u9.total, datos.u9.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u9.total, datos.u9.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u9.total, datos.u9.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.u9.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u9.total, datos.u9.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.u9.total, datos.u9.nuevos) }}%
                                                </template>

                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>

                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.u35" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región U35">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around  q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u35.total, datos.u35.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u35.total, datos.u35.localizados) }}%
                                                </template>

                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u35.total, datos.u35.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u35.total, datos.u35.conciliados) }}%
                                                </template>

                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u35.total, datos.u35.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u35.total, datos.u35.etiquetados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u35.total, datos.u35.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u35.total, datos.u35.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u35.total, datos.u35.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u35.total, datos.u35.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u35.total, datos.u35.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u35.total, datos.u35.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.u35.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u35.total, datos.u35.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.u35.total, datos.u35.nuevos) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.u36" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región U36">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around  q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u36.total, datos.u36.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u36.total, datos.u36.localizados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u36.total, datos.u36.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u36.total, datos.u36.conciliados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u36.total, datos.u36.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u36.total, datos.u36.etiquetado) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u36.total, datos.u36.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u36.total, datos.u36.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u36.total, datos.u36.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u36.total, datos.u36.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u36.total, datos.u36.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u36.total, datos.u36.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.u36.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u36.total, datos.u36.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.u36.total, datos.u36.nuevos) }}%
                                                </template>

                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.u37" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región U37">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around   q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u37.total, datos.u37.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u37.total, datos.u37.localizados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u37.total, datos.u37.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u37.total, datos.u37.conciliados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u37.total, datos.u37.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u37.total, datos.u37.etiquetados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u37.total, datos.u37.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u37.total, datos.u37.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u37.total, datos.u37.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u37.total, datos.u37.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u37.total, datos.u37.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u37.total, datos.u37.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.u37.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u37.total, datos.u37.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.u37.total, datos.u37.nuevos) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.u38" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región U38">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around  q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u38.total, datos.u38.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u38.total, datos.u38.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u38.total, datos.u38.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u38.total, datos.u38.conciliados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u38.total, datos.u38.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u38.total, datos.u38.etiquetados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.u38.total, datos.u38.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u38.total, datos.u38.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u38.total, datos.u38.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u38.total, datos.u38.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u38.total, datos.u38.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.u38.total, datos.u38.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos</div>
                                            <div class="text-h6 text-primary"> {{ datos.u38.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly :value="progressLabel(datos.u38.total, datos.u38.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.u38.total, datos.u38.nuevos) }}%
                                                </template>

                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.umae_raza" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región UMAE La Raza">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around  q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_raza.total, datos.umae_raza.localizados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_raza.total, datos.umae_raza.conciliados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_raza.total, datos.umae_raza.etiquetados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_raza.total,
                                                    datos.umae_raza.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_raza.total, datos.umae_raza.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_raza.total, datos.umae_raza.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_raza.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_raza.total, datos.umae_raza.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.umae_raza.total, datos.umae_raza.nuevos)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.umae_xxi" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región UMAE S. XXI">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around  q-col-gutter-md" v-if="datos">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_xxi.total, datos.umae_xxi.localizados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_xxi.total, datos.umae_xxi.conciliados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_xxi.total, datos.umae_xxi.etiquetados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_xxi.total,
                                                    datos.umae_xxi.noIdentificados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_xxi.total, datos.umae_xxi.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.umae_xxi.total, datos.umae_xxi.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.umae_xxi.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.umae_xxi.total, datos.umae_xxi.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.umae_xxi.total, datos.umae_xxi.nuevos) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-if="datos && datos.pruebas" header-class="bg-white text-primary" popup
                    icon="mdi-chart-arc" label="Región de Pruebas">
                    <q-separator />
                    <q-card>
                        <q-card-section>
                            <div class="row justify-around  q-col-gutter-md">
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Localizados</div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.localizados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.localizados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-1" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.pruebas.total, datos.pruebas.localizados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Conciliados </div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.conciliados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.conciliados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-2" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.pruebas.total, datos.pruebas.conciliados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Etiquetados </div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.etiquetados }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.etiquetados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-3" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.pruebas.total, datos.pruebas.etiquetados) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">No Identificados </div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.noIdentificados
                                            }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.noIdentificados)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-4" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.pruebas.total, datos.pruebas.noIdentificados)
                                                    }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Bajas </div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.bajas }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.bajas)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-5" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.pruebas.total, datos.pruebas.bajas) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Total </div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.total }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.total)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-6" class="text-green">
                                                <template>
                                                    {{ progressLabel(datos.pruebas.total, datos.pruebas.total) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="col-auto">
                                    <q-card class="q-pa-sm shadow-0">
                                        <q-card-section class="text-center">
                                            <div class="text-h6">Nuevos </div>
                                            <div class="text-h6 text-primary"> {{ datos.pruebas.nuevos }}</div>
                                        </q-card-section>
                                        <q-separator />
                                        <q-card-section class="flex flex-center">
                                            <q-knob readonly
                                                :value="progressLabel(datos.pruebas.total, datos.pruebas.nuevos)"
                                                show-value size="90px" :thickness="0.22" color="green"
                                                track-color="green-7" class="text-green">
                                                <template>
                                                    + {{ progressLabel(datos.pruebas.total, datos.pruebas.nuevos) }}%
                                                </template>
                                            </q-knob>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
            </q-list>
        </q-scroll-area>
    </q-page>
</template>

<script>
import axios from "axios";
import Chart from 'chart.js'
export default {
    name: "Dashboard",
    components: {
    },
    data() {
        return {
            datos: null,
            totalesglobales: null,
            datosPersonal: null,
            fechaI: '',
            fechaF: '',
            indicadores: []
        };
    },
    computed: {



        usuarioStore() {
            return this.$store.state.usuario;
        },
    },
    async created() {
        await this.getApiData();
    },

    mounted() {

    },
    methods: {
        async getApiData() {
            try {
                let respuesta = await axios.get("Configuracion/GetTotalBienes/" + this.usuarioStore._id + '/' + this.usuarioStore.rol);
                this.datos = respuesta.data;
                console.log(this.datos)

                this.crearGraficaPorUnidad()
                this.crearGraficaGlobal()
            } catch (error) {
                console.error(error);
            }
        },

        async GetTotalBienesPersonal() {
            this.datosPersonal = []
            try {
                let respuesta = await axios.get("Configuracion/GetTotalBienesPersonal/" + this.usuarioStore.baseDatos + '/' + this.usuarioStore._id + '/' + this.usuarioStore.rol + '/' + this.fechaI + '/' + this.fechaF);
                this.datosPersonal = respuesta.data;
                console.log(this.datosPersonal)
                this.crearGrafica()
            } catch (error) {
                console.error(error);
            }
        },

        progressLabel(total, parcial) {
            if (!total || total === 0) return 0;
            return Number(((parcial / total) * 100).toFixed(2));
        },

        crearGraficaPorUnidad() {
            const unidades = Object.keys(this.datos).filter(k => k !== 'pruebas')

            const categorias = ['localizados', 'conciliados', 'etiquetados', 'noIdentificados', 'baja', 'total', 'nuevos']
            const colores = [
                '#4CAF50', // localizados
                '#8BC34A', // conciliados
                '#CDDC39', // etiquetados
                '#FFEB3B', // noIdentificados
                '#FFC107', // BAJAS
                '#FF9800', // total
                '#FF5722', // NUEVOS
            ]

            // const datasets = categorias.map((categoria, index) => ({
            //     label: categoria.charAt(0).toUpperCase() + categoria.slice(1),
            //     data: unidades.map(u => this.datos[u][categoria]),
            //     backgroundColor: colores[index]
            // }))
            const datasets = categorias.map((categoria, index) => ({
                label: categoria.charAt(0).toUpperCase() + categoria.slice(1),
                data: unidades.map(u => this.datos[u] ? this.datos[u][categoria] : 0), // 👈 validamos null
                backgroundColor: colores[index]
            }))

            new Chart(this.$refs.chartUnidad, {
                type: 'bar',
                data: {
                    labels: unidades,
                    datasets
                },
                options: {
                    responsive: true,
                    scales: {
                        yAxes: [{ ticks: { beginAtZero: true } }],
                        xAxes: [{ stacked: false }]
                    }
                }
            })
        },

        crearGraficaGlobal() {
            const global = { localizados: 0, conciliados: 0, etiquetados: 0, noIdentificados: 0, nuevos: 0, bajas: 0, total: 0 }

            // Object.keys(this.datos).forEach(k => {
            //     if (k !== 'pruebas') {
            //         Object.keys(global).forEach(campo => {
            //             global[campo] += this.datos[k][campo]
            //         })
            //     }
            // })

            Object.keys(this.datos).forEach(k => {
                if (k !== 'pruebas' && this.datos[k]) { // 👈 validamos null
                    Object.keys(global).forEach(campo => {
                        global[campo] += this.datos[k][campo] || 0
                    })
                }
            })

            this.totalesglobales = global
            new Chart(this.$refs.chartGlobal, {
                type: 'pie',
                data: {
                    labels: ['Localizados', 'Conciliados', 'Etiquetados', 'No Identificados', 'Bajas', 'Nuevos'],
                    datasets: [{
                        label: 'Totales Globales',
                        data: [
                            global.localizados,
                            global.conciliados,
                            global.etiquetados,
                            global.noIdentificados,
                            global.bajas,
                            global.nuevos,
                        ],
                        backgroundColor: [
                            '#4CAF50', // localizados
                            '#8BC34A', // conciliados
                            '#CDDC39', // etiquetados
                            '#FFEB3B', // noIdentificados
                            '#FFC107', // BAJAS
                            '#FF5722', // NUEVOS
                        ]
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true
                }
            })

            this.indicadores = [
                { titulo: "Localizado", total: this.totalesglobales.localizados, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.localizados), icon: "place", color: "green-3" },
                { titulo: "Conciliado", total: this.totalesglobales.conciliados, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.conciliados), icon: "done_all", color: "green-4" },
                { titulo: "Etiquetado", total: this.totalesglobales.etiquetados, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.etiquetados), icon: "label", color: "green-5" },
                { titulo: "No Identificado", total: this.totalesglobales.noIdentificados, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.noIdentificados), icon: "help", color: "green-6" },
                { titulo: "Bajas", total: this.totalesglobales.bajas, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.bajas), icon: "trending_down", color: "green-7" },
                { titulo: "Total", total: this.totalesglobales.total, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.total), icon: "functions", color: "green-8" },
                { titulo: "Nuevos", total: this.totalesglobales.nuevos, progress: this.progressLabel(this.totalesglobales.total, this.totalesglobales.nuevos), icon: "new_releases", color: "green-9" }
            ]
        },

        crearGrafica() {
            const nombres = this.datosPersonal.map(d => d.nombre);
            const numeroBienes = this.datosPersonal.map(d => d.numeroBienes);
            const numeroBienesNuevos = this.datosPersonal.map(d => d.numeroBienesNuevos);
            const numeroBienesTotal = this.datosPersonal.map(d => d.numeroBienesTotal);

            new Chart(this.$refs.bienesChart, {
                type: 'bar',
                data: {
                    labels: nombres,
                    datasets: [
                        {
                            label: 'Número de Bienes',
                            data: numeroBienes,
                            backgroundColor: '#4caf50',
                        },
                        {
                            label: 'Bienes Nuevos',
                            data: numeroBienesNuevos,
                            backgroundColor: '#2196f3',
                        },
                        {
                            label: 'Bienes Totales',
                            data: numeroBienesTotal,
                            backgroundColor: '#ff9800',
                        }
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: true, // ahora sí mostramos leyenda porque hay varios datasets
                            position: 'top'
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: 'Número de Bienes'
                            }
                        },
                        x: {
                            title: {
                                display: true,
                                text: 'Usuario'
                            }
                        }
                    }
                }
            });
        }

    },
};
</script>